import React from "react";
import CelticPersonaPage from "@/components/CelticPersonaPage";
import { DruideChat } from "@/components/CelticChats";
import { Trees } from "lucide-react";

const CONTENT = {
  fr: {
    name: "Le Druide", kicker: "Le Druide · gratuit · illimité",
    title: <>Le <span className="italic" style={{ color: "var(--violet-glow)" }}>Druide</span>, sage du Nemeton.</>,
    intro: "Prêtre-philosophe, astronome et juge, le druide (Draoi) était le sommet spirituel de la société celte. Il présidait les rites du bois sacré, lisait le ciel et conseillait les rois. Ici, il ne prédit rien et n'impose rien : il suggère et t'accompagne, avec humour et érudition, pour que tu apprennes à lire ta propre vie comme on lit les saisons.",
    facts: [
      ["Vingt ans d'étude", "César rapporte que certains druides étudiaient jusqu'à vingt ans, en apprenant tout par cœur, sans rien écrire."],
      ["Le Nemeton", "Le bois sacré, souvent de chênes, où se tenaient l'enseignement, les rites et les grandes décisions."],
      ["Le calendrier de Coligny", "Un calendrier gaulois en bronze qui accordait les mois lunaires et l'année solaire : la science du temps."],
    ],
    chatTitle: "Consulte le Druide",
  },
  en: {
    name: "The Druid", kicker: "The Druid · free · unlimited",
    title: <>The <span className="italic" style={{ color: "var(--violet-glow)" }}>Druid</span>, sage of the Nemeton.</>,
    intro: "Priest-philosopher, astronomer and judge, the druid (Draoi) was the spiritual summit of Celtic society. He led the rites of the sacred grove, read the sky and counselled kings. Here he predicts nothing: he teaches you, with humour and learning, to read your own life the way one reads the seasons.",
    facts: [
      ["Twenty years of study", "Caesar reports that some druids studied for up to twenty years, learning everything by heart, writing nothing down."],
      ["The Nemeton", "The sacred grove, often of oaks, where teaching, rites and great decisions took place."],
      ["The Coligny calendar", "A bronze Gaulish calendar reconciling lunar months and the solar year: the science of time."],
    ],
    chatTitle: "Consult the Druid",
  },
};

export default function Druide() {
  return (
    <CelticPersonaPage id="druide" Icon={Trees} accent="#a67bff" content={CONTENT}>
      <DruideChat />
    </CelticPersonaPage>
  );
}
